@if (!isDynamicdashboard()) {
  <h2><a [ecommerceRouterLink]="['/:lang/myfleet/machines']"><mibp-resource-string key="Fleet_Title"></mibp-resource-string></a></h2>
}
<mibp-chart-pie [doughnut]="true" [loading]="isLoading()" [data]="fleetChartData()" width="250px" [height]="null" [aspectRatio]="1"  [colors]="['#A08C64','#101010','#BEAF93','#E6E6E6']" [total]="fleetTotalDetails()" [cutoutPercentage]="85"></mibp-chart-pie>

<div class="statuses">
  <ul class="fleet-status-list">
    <ul>
      <li> <span class="fleet-status active" (click)="activeInfo.open($event.target)" ><mibp-resource-string key="MyFleet_Active" ></mibp-resource-string>: {{ fleetActiveCount() }}</span></li>
      <li> <span class="fleet-status onorder" (click)="onorderInfo.open($event.target)"><mibp-resource-string key="MyFleet_OnOrder"></mibp-resource-string>: {{ fleetOnOrderCount() }}</span></li>
    </ul>
    <ul>
      <li><span class="fleet-status inactive" (click)="inactiveInfo.open($event.target)"><mibp-resource-string key="MyFleet_InActive"></mibp-resource-string>: {{ fleetInActiveCount() }}</span></li>
    </ul>
  </ul>
</div>

<mibp-new-popover #activeInfo>
  <p><strong><mibp-resource-string key="MyFleet_Active"></mibp-resource-string></strong>: <mibp-resource-string key="MyFleet_Active_Description"></mibp-resource-string></p>
</mibp-new-popover>

<mibp-new-popover #inactiveInfo>
  <p><strong><mibp-resource-string key="MyFleet_InActive"></mibp-resource-string></strong>: <mibp-resource-string key="MyFleet_InActive_Description"></mibp-resource-string></p>
</mibp-new-popover>

<mibp-new-popover #onorderInfo>
  <p><strong><mibp-resource-string key="MyFleet_OnOrder"></mibp-resource-string></strong>: <mibp-resource-string key="MyFleet_OnOrder_Description"></mibp-resource-string></p>
</mibp-new-popover>

<mibp-new-popover #decommisionedInfo>
  <p><strong><mibp-resource-string key="MyFleet_Decommissioned"></mibp-resource-string></strong>: <mibp-resource-string key="MyFleet_Decommissioned_Description"></mibp-resource-string></p>
</mibp-new-popover>
